import { Typography } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import { Note, Today } from '@material-ui/icons';
import { format, parse } from 'date-fns';
import get from 'lodash/get';
import React from 'react';
import { withRouter } from 'react-router';
import { compose } from 'recompose';
import styled from 'styled-components';
import { withScope } from '../../../contexts/ScopeContext';
import { withTheme } from '@/se/theme';
import responsive from '@/se/utilities/responsive';
import { translateToTz } from '../../../util/dateTime';
import { EventLogEntry, EventLogTime1, IconWrapper } from '../patient/views/components';

const Span = styled.span`
  display: flex;
  flex: 1;
  > * {
    margin-right: 1em;
  }
`;

const VisitItem = styled.div`
  border-top: 1px solid ${withTheme(theme => theme.border.color.default.string())};
  border-right: 0;
  position: relative;
  display: flex;
  flex-flow: row;
  align-items: baseline;
  justify-content: space-between;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  line-height: 1.4;

  &:last-of-type {
    border-bottom: 1px solid ${withTheme(theme => theme.border.color.default.string())};
  }

  ${responsive.md.andSmaller`
    flex-flow: column-reverse;
    align-items: flex-start;

    > div:first-of-type {
      margin-top: .25rem;
    }
  `}
  :hover {
    opacity: 0.8;
    cursor: pointer;
  }
  text-decoration: none;
  color: ${withTheme((theme, props) => theme.textColor.string())};
`;

const PatientVisits = compose(
  withRouter,
  withScope
)(({ visits, currentVisit, location, history, scope }) => {
  const onClick = id => e => {
    history.push({
      pathname: `${id}`,
      search: location.search,
    });
    document.location.reload();
  };

  return (
    <Box>
      <Typography variant="h2">Patient Visits</Typography>
      {visits.map(visit => (
        <VisitItem key={visit.id} onClick={onClick(visit.id)}>
          <Span>
            <label>{visit.visit}</label>
            <EventLogTime1>
              {format(translateToTz(get(scope, 'hospital.timezone.id'))(parse(visit.startTime)), 'MM/DD/YYYY HH:mm:ss')}
            </EventLogTime1>
            {!!visit.isCanceled && (
              <Typography variant="body2" color="textSecondary" style={{ fontStyle: 'italic' }}>
                Canceled
              </Typography>
            )}
          </Span>
          <EventLogEntry>
            <IconWrapper>
              {visit.id === currentVisit ? <Today fontSize={'small'} /> : <Note fontSize={'small'} />}
            </IconWrapper>
            {get(visit, 'procedureType', '')}
          </EventLogEntry>
        </VisitItem>
      ))}
    </Box>
  );
});

export default props => (props.visits ? <PatientVisits {...props} /> : null);
